// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clickable {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.clickable:hover {\n  color: maroon;\n}", "",{"version":3,"sources":["webpack://./src/components/NpcMenu/NpcMenu.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".clickable {\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.clickable:hover {\n  color: maroon;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
